<script>
    import Modal from 'views/components/modals/Modal.svelte'
    import ContentLabel from 'views/components/contentLabel/ContentLabel.svelte'

    export let action = null

    let modalIsOpen = true

    const isStudent = ACL.checkRole(ACL.roles.STUDENT)

    const isForStudentPlanner = isStudent && action === 'planner'
    const currentGroup = Backbone.View.layout?.menubar?.getGroup()
    const groupList = Backbone.Collection.groups.reduce((groups, model) => {
        // For students navigating to the planner, only list groups that have an active planner.
        if (isForStudentPlanner && !model.get('has_active_planner')) {
            return groups
        }
        groups.push(model)
        return groups
    }, [])

    function navigateToGroup(model) {
        modalIsOpen = false
        // For teachers navigating from a content page to another group,
        // check if the same content is present in the other group.
        // If so, navigate there directly.
        const currentId = parseInt(window.app.controller.activeParams[0])
        const level = window.app.controller.activePath[0]
        if (
            Backbone.Model.user.get('is_teacher') &&
            currentId &&
            ['chapters', 'sections', 'activities'].includes(level) &&
            ['show', 'progress', 'author'].includes(action)
        ) {
            const similarModel = getSimilarContent(currentId, Backbone.Collection[level], model)
            if (similarModel) {
                Backbone.history.navigate(`${level}/${action}/${similarModel.id}`, { trigger: true })
                return
            }
        }

        // For students navigating to results, the URL format is different
        if (action === 'results' && Backbone.Model.user.get('is_student')) {
            Backbone.history.navigate(`students/results/${model.id}/${Backbone.Model.user.id}`, { trigger: true })
            return
        }

        // In all other cases, navigate to the root of the group
        Backbone.history.navigate(`groups/${action}/${model.id}`, { trigger: true })
    }

    function getSimilarContent(currentId, collection, groupModel) {

        // Get the source id of the current content
        const sourceId = collection.get(currentId)?.getSourceId()
        if (!sourceId) {
            return
        }

        // Check if the chosen group contains content with the same source id
        return collection.find((model) => {
            return (model.getSourceId() === sourceId && model.getGroupModel().id === groupModel.id)
        })
    }
</script>

<Modal
    title={isStudent ? window.i18n.gettext('Select your course') : window.i18n.gettext('Select your group')}
    canBeClosedWithEscapeKey={true}
    bind:isOpen={modalIsOpen}
>
    <section>
        {#each groupList as model (model.id)}
            <button
                class="group-item"
                class:is-current={model === currentGroup}
                class:is-favorite={!isStudent && model.get('is_favorite')}
                on:click={() => navigateToGroup(model)}
            >
                <ContentLabel
                    {model}
                    labelSuffix={isStudent ? model.get('name') : model.getCourseModel().get('name')}
                    smallText={true}
                ></ContentLabel>
            </button>
        {:else}
            <span>
                {#if isStudent}
                    <!-- eslint-disable-next-line svelte/no-at-html-tags -->
                    {@html window.i18n.gettext('You are not in a group yet. <a href=\'/users/join\'>Add a group</a> to continue.')}
                {:else}
                    <!-- eslint-disable-next-line svelte/no-at-html-tags -->
                    {@html window.i18n.gettext('You haven\'t added a group yet. <a href=\'/groups/pick_course\'>Add a group</a> to continue.')}
                {/if}
            </span>
        {/each}
    </section>
</Modal>

<style lang="scss">
    section {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .group-item {
        border: 1px solid $background-gray;
        padding: 8px;
        border-radius: $label-border-radius;

        :global(> *) {
            width: 100%;
        }

        &.is-current {
            @include selectable-item-checked-state;
            border-color: $blue-10;

            :global(> *) {
                color: $blue;
            }
        }

        &.is-favorite + :not(.is-favorite) {
            margin-top: 24px;
        }

        &:hover {
            @include selectable-item-hover-state;

            :global(> *) {
                color: $blue;
            }
        }
    }
</style>
